import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_ENGAGEMENT_SIGN_FORM_MOBILE_OPT_IN_CONFIG = defineFcm('engagement_sign_form_mobile_opt_in_config')
	.asJson(
		createShapeNormalizer({
			type: 'array',
			shape: { type: 'string', normalizer: (country) => country.toLowerCase() },
		}),
	)
	.withDefault([])
	.toConfig({
		owner: 'TBD',
		scope: 'TBD',
		context: 'petition page',
		description: `List of country codes for which the mobile opt-in checkbox should be available.
			That checkbox then allows to enter a mobile phone number to receive updates and recommendations via text or Whatsapp.
			Related experiment: engagement_sign_form_mobile_opt_in`,
		import: false,
		template: ['US', 'CA'],
		deprecated: 'No references found. Safe to delete after 2026-09-01.',
	});
